import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import DropdownSelect from '../../components/dropdown-select';
import StickyBar from '../../components/sticky-bar';
import ProductColorSelect from '../../components/product-color-select';
$(() => {
    RevealWhenVisible.init();
    DropdownSelect.init();
    StickyBar.init();
    ProductColorSelect.init();
});
